export const Colors = {
  primary: 'rgb(5, 174, 75)',
  white: '#FFF',
  black: '#000',
  grey: 'rgb(179, 190, 194)',
  red: 'rgb(226, 9, 9)',
  brightRed: '#FB5C5C',
  greenMain: 'rgb(5, 174, 75)',
  greenSecondary: 'rgb(205, 239, 219)',
  blueMain: 'rgb(0, 39, 51)',
  blueSecondary: 'rgb(0, 39, 51, 0.5)',
  orange: '#F2A341',
  brightOrange: '#FFC400',
  purple: '#8777D9',
  grayLight: '#F5F5F5',
  blue: '#018FFB',
  lightBlue: '#3799E0',
  greenStrong: 'rgb(76, 112, 97)',
  greenBright: 'rgb(52, 199, 89)',
  greenAlternate: 'rgb(76, 104, 112)',
  blueAlternate: 'rgb(159, 174, 178)',
  blueBright: 'rgb(226, 231, 232)',
  greyStrong: 'rgb(142, 142, 147)',
  greySecondary: 'rgb(241, 242, 243)',
  tomatoRed: 'rgb(222, 61, 51)',
  tomatoRedLight: 'rgb(222, 61, 51, 0.2)',
  yellowBright: '#FFC400',
  orangeBright: 'rgb(255, 139, 0)',
  purpleBright: 'rgb(142, 59, 246)',
  semiWhite: 'rgb(250, 250, 250)',
  semiWhiteDarker: 'rgb(245, 247, 251)',
  primaryIcon: 'rgb(76, 112, 97)',
  secondaryIcon: 'rgba(76, 104, 112, 0.5)',
  alternateIcon: 'rgba(142, 142, 147, 0.5)',
  primaryText: 'rgb(0, 39, 51)',
  secondaryText: 'rgb(76, 104, 112)',
  alternateText: 'rgb(142, 142, 147)',
  scaffoldColor: 'rgb(245, 247, 251)',
  modalColor: '#FFF',
  dialogColor: '#FFF',
  modalBarrierColor: 'rgba(0, 0, 0, 0.5)',
  bottomSheetColor: '#FFF',
  dividerColor: 'rgba(0, 0, 0, 0.12)',
  skeletonColor: 'rgb(233, 234, 243)',
  containerBackgroundGrey: 'rgba(204, 212, 214, 0.8)',
  formFieldBackgroundColor: 'rgb(241, 242, 243)',
};

export const Fonts = {
  primary: 'Poppins',
  secondary: 'Lato',
};

export const AssetPathsRelative = {
  logoGreenPNG: '../assets/images/logo/logo-green.png',
  imagePlaceHolderPNG: '../assets/images/placeholders/image_placeholder.png',
};
